import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import Row from '../shared/table/Row';
import SelectableRow from '../shared/table/SelectableRow';
import Table from '../shared/table/Table';

const VehiclesTable = ({ vehicles, onVehicleClick }) => {
  const isTabletView = useSelector((state) => state.screen.isTabletView);
  const tableRows = useMemo(
    () =>
      vehicles.map((vehicle, i) => (
        <SelectableRow key={i} onClick={() => onVehicleClick(vehicle.vin)}>
          <Row children={vehicle.vin} />
          <Row
            children={
              <div>
                {vehicle.brand.name} {vehicle.model.name}
              </div>
            }
          />
          <Row children={vehicle.number || '-'} />
          {!isTabletView && (
            <Row children={<div>{`${vehicle.client.lastName} ${vehicle.client.firstName}`.trim()}</div>} />
          )}
        </SelectableRow>
      )),
    [isTabletView, vehicles, onVehicleClick],
  );

  return <Table columns={isTabletView ? mobileColumns : columns} data={tableRows} onRowClick={() => ({})} />;
};

const mobileColumns = [
  { name: 'VIN', className: 'w-[40%]' },
  { name: 'Модель', className: 'w-[40%]' },
  { name: 'Номер', className: 'w-[20%]' },
];

const columns = [{ name: 'VIN' }, { name: 'Модель' }, { name: 'Номер' }, { name: 'Клієнт' }];

export default VehiclesTable;
